import { SxStyles } from 'src/types/theme';
import { COLORS } from 'src/theme/palette';

const styles: SxStyles = {
  form: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
  row: {
    marginTop: '23px',
    '&:last-of-type': {
      marginTop: 'auto',
    },
  },
  buttons: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '40px',
  },
  button: {
    marginRight: '10px',
    paddingLeft: '48px',
    paddingRight: '48px',
  },
  searchInput: {
    width: '400px',
    '& svg': {
      fill: COLORS.black40,
    },
  },
  label: {
    color: COLORS.black60,
    marginBottom: '8px',
  },
  caption: {
    color: COLORS.black60,
  },
  expertiseButton: {
    textTransform: 'capitalize',
  },
  matchedResourcesCountContainer: {
    marginLeft: '20px',
  },
};

export default styles;
